import { Link } from "react-router-dom";
import { Truck, Car, Move, ShieldCheck, Recycle, KeyRound, ArrowRight } from "lucide-react";

const ICONS = {
  "tow-truck": Truck,
  "tow-flatbed": Truck,
  "car-transport": Move,
  "shield-check": ShieldCheck,
  "key-round": KeyRound,
  "recycle": Recycle,
  default: Car,
};

export default function ServicesGrid({ services = [] }) {
  return (
    <section className="bg-white py-14 sm:py-16 lg:py-20" data-testid="services-grid">
      <div className="max-w-6xl mx-auto px-4 lg:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-extrabold text-txt-900">Nos services</h2>
          <p className="text-txt-500 mt-2 max-w-lg mx-auto">Des solutions adaptées à toutes les situations, avec des professionnels qualifiés.</p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
          {services.map((s) => {
            const Icon = ICONS[s.icon] || ICONS.default;
            return (
              <Link
                key={s.slug}
                to={`/services/${s.slug}`}
                className="group bg-white border border-surface-200 hover:border-brand hover:shadow-card rounded-2xl p-5 transition-all"
                data-testid={`service-card-${s.slug}`}
              >
                <div className="w-12 h-12 bg-brand-50 group-hover:bg-brand rounded-xl flex items-center justify-center mb-4 transition-colors">
                  <Icon size={24} className="text-brand group-hover:text-white transition-colors" />
                </div>
                <div className="font-bold text-sm text-txt-900 leading-tight">{s.title}</div>
                <p className="text-xs text-txt-500 mt-1.5 line-clamp-2">{s.short_description}</p>
                <div className="mt-3 flex items-center gap-1 text-brand text-xs font-semibold opacity-0 group-hover:opacity-100 transition-opacity">
                  En savoir plus <ArrowRight size={12} />
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
